import { getFrontendProperties } from './Config';

// Timeline item types
export const TYPE_DEFAULT = 'DEFAULT';

export const TYPE_IMAGING_MAGNET = 'TYPE_IMAGING_MAGNET';
export const TYPE_IMAGING_TOMOGRAPHY = 'TYPE_IMAGING_TOMOGRAPHY';
export const TYPE_IMAGING_ISOTOPERESEARCH = 'TYPE_IMAGING_ISOTOPERESEARCH';
export const TYPE_IMAGING_ISOTOPETREATMENT = 'TYPE_IMAGING_ISOTOPETREATMENT';
export const TYPE_IMAGING_RESEARCHVISIT = 'TYPE_IMAGING_RESEARCHVISIT';
export const TYPE_IMAGING_CAREVISIT = 'TYPE_IMAGING_CAREVISIT';
export const TYPE_IMAGING_TRANSILLUMINATIONRESEARCH =
  'TYPE_IMAGING_TRANSILLUMINATIONRESEARCH';
export const TYPE_IMAGING_XRAYRESEARCH = 'TYPE_IMAGING_XRAYRESEARCH';
export const TYPE_IMAGING_ULTRASOUNDRESEARCH =
  'TYPE_IMAGING_ULTRASOUNDRESEARCH';
export const TYPE_IMAGING_FACEANDTEETHRESEARCH =
  'TYPE_IMAGING_FACEANDTEETHRESEARCH';
export const TYPE_IMAGING_MAMMOGRAPGHYRESEARCH =
  'TYPE_IMAGING_MAMMOGRAPGHYRESEARCH';
export const TYPE_IMAGING_BONEDENSITYRESEARCH =
  'TYPE_IMAGING_BONEDENSITYRESEARCH';

export const TYPE_FIMLAB = 'FIMLAB';
export const TYPE_HEARING_DEVICE_MODELING = 'TYPE_HEARING_DEVICE_MODELING';
export const TYPE_HEARING_DEVICE_FIXING = 'TYPE_HEARING_DEVICE_FIXING';
export const TYPE_SLEEP_CLINIC = 'TYPE_SLEEP_CLINIC';
export const TYPE_COXA_TREATMENT_PERIOD = 'TYPE_COXA_TREATMENT_PERIOD';

export const TYPE_VIDEO_CONFERENCE = 'REMOTE';

export const TYPE_GTI = 'GTI';
export const TYPE_REFERRAL = 'REFERRAL';

// config per each type
export const config = {
  [TYPE_VIDEO_CONFERENCE]: {
    icon: {
      type: 'fa',
      name: 'fa-laptop',
    },
    title: {
      message: 'video.conference.timelineitem.title',
    },
    color: 'blue',
  },
  [TYPE_FIMLAB]: {
    icon: {
      type: 'custom',
      name: 'lab',
    },
    title: {
      message: 'fimlab.timelineitem.title',
    },
    hideHours: true,
    color: 'orange',
  },
  [TYPE_REFERRAL]: {
    icon: {
      type: 'custom',
      name: 'referral',
    },
    title: {
      defaultMessage: 'referral.title.default',
    },
    hideHours: true,
    color: 'blue',
  },
  [TYPE_IMAGING_TOMOGRAPHY]: {
    icon: {
      type: 'custom',
      name: 'imaging',
    },
    title: {
      message: 'imaging.tomography.timelineitem.title',
    },
    color: 'green',
  },
  [TYPE_IMAGING_MAGNET]: {
    icon: {
      type: 'custom',
      name: 'imaging',
    },
    title: {
      message: 'imaging.magnet.timelineitem.title',
    },
    color: 'green',
  },
  [TYPE_IMAGING_ISOTOPERESEARCH]: {
    icon: {
      type: 'custom',
      name: 'imaging',
    },
    title: {
      message: 'imaging.isotoperesearch.timelineitem.title',
    },
    color: 'green',
  },
  [TYPE_IMAGING_ISOTOPETREATMENT]: {
    icon: {
      type: 'custom',
      name: 'imaging',
    },
    title: {
      message: 'imaging.isotopetreatment.timelineitem.title',
    },
    color: 'green',
  },
  [TYPE_IMAGING_RESEARCHVISIT]: {
    icon: {
      type: 'custom',
      name: 'imaging',
    },
    title: {
      message: 'imaging.researchvisit.timelineitem.title',
    },
    color: 'green',
  },
  [TYPE_IMAGING_CAREVISIT]: {
    icon: {
      type: 'custom',
      name: 'imaging',
    },
    title: {
      message: 'imaging.carevisit.timelineitem.title',
    },
    color: 'green',
  },
  [TYPE_IMAGING_TRANSILLUMINATIONRESEARCH]: {
    icon: {
      type: 'custom',
      name: 'imaging',
    },
    title: {
      message: 'imaging.transilluminationresearch.timelineitem.title',
    },
    color: 'green',
  },
  [TYPE_IMAGING_XRAYRESEARCH]: {
    icon: {
      type: 'custom',
      name: 'imaging',
    },
    title: {
      message: 'imaging.xrayresearch.timelineitem.title',
    },
    color: 'green',
  },
  [TYPE_IMAGING_ULTRASOUNDRESEARCH]: {
    icon: {
      type: 'custom',
      name: 'imaging',
    },
    title: {
      message: 'imaging.ultrasoundresearch.timelineitem.title',
    },
    color: 'green',
  },
  [TYPE_IMAGING_FACEANDTEETHRESEARCH]: {
    icon: {
      type: 'custom',
      name: 'imaging',
    },
    title: {
      message: 'imaging.faceandteethresearch.timelineitem.title',
    },
    color: 'green',
  },
  [TYPE_IMAGING_MAMMOGRAPGHYRESEARCH]: {
    icon: {
      type: 'custom',
      name: 'imaging',
    },
    title: {
      message: 'imaging.mammographyresearch.timelineitem.title',
    },
    color: 'green',
  },
  [TYPE_IMAGING_BONEDENSITYRESEARCH]: {
    icon: {
      type: 'custom',
      name: 'imaging',
    },
    title: {
      message: 'imaging.bonedensityresearch.timelineitem.title',
    },
    color: 'green',
  },
  [TYPE_HEARING_DEVICE_FIXING]: {
    icon: {
      type: 'custom',
      name: 'assistive-listening-systems',
    },
    title: {
      message: 'hearing.device.fixing.timelineitem.title',
    },
    color: 'blue',
  },
  [TYPE_HEARING_DEVICE_MODELING]: {
    icon: {
      type: 'custom',
      name: 'assistive-listening-systems',
    },
    title: {
      message: 'hearing.device.modeling.timelineitem.title',
    },
    color: 'blue',
  },
  [TYPE_SLEEP_CLINIC]: {
    icon: {
      type: 'custom',
      name: 'sleepClinic',
    },
    title: {
      message: 'sleepclinic.timelineitem.title',
    },
    color: 'blue',
  },
  [TYPE_COXA_TREATMENT_PERIOD]: {
    icon: {
      type: 'custom',
      name: 'hospitalWard',
    },
    title: {
      message: 'coxa.treatment.period.timelineitem.title',
    },
    color: 'blue',
    hideHours: true,
  },
  [TYPE_DEFAULT]: {
    icon: {
      type: 'fa',
      name: 'icon-stethoscope',
    },
    title: {
      message: 'default.timelineitem.title',
    },
    color: 'blue',
  },
};

export const visitTypeRemoteCodes = () =>
  getFrontendProperties().visitTypeRemoteCodes
    ? getFrontendProperties().visitTypeRemoteCodes.split(',')
    : [];
export const visitTypePhoneCodes = () =>
  getFrontendProperties().visitTypePhoneCodes
    ? getFrontendProperties().visitTypePhoneCodes.split(',')
    : [];
export const coxaAdditionalInfoResources = () =>
  getFrontendProperties().coxaAdditionalInfoResources
    ? getFrontendProperties().coxaAdditionalInfoResources.split(',')
    : [];
